<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        
        <a-row :gutter="12" style="margin:16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item
            style="margin-bottom:0px;width:100%"
            label=""
            :required="false"
          >
          <a-select placeholder="所属课程">
            <a-select-option value="">所有课程</a-select-option>
            <a-select-option value="0">语文</a-select-option>
            <a-select-option value="1">数学</a-select-option>
            <a-select-option value="2">拉丁舞</a-select-option>
          </a-select>

          </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
            style="margin-bottom:0px;width:100%"
            label=""
            :required="false"
          > 
            <a-select placeholder="班级状态">
              <a-select-option value="">所有状态</a-select-option>
              <a-select-option value="0">待开班</a-select-option>
              <a-select-option value="1">开班中</a-select-option>
              <a-select-option value="2">已结班</a-select-option>
            </a-select>
            <!-- <j-dict-select-tag v-model="queryParam.courseStatus" placeholder="请选择更新状态" 
                  dictCode="shelf_status"/> -->
            </a-form-item>
          </a-col>
          
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="请输入班级名称" v-model="queryParam.className"></a-input>
            </a-form-item>
          </a-col>
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button @click="courseCreate()" type="primary" icon="plus" style="float:right;">新增班级</a-button>

        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource1"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        
        <div slot="courseinfo" slot-scope="text, record">
          <div class="course-img">
            <img :src="record.courseCoverUrl" alt="" width="86">
          </div>
          <div class="course-right">
            <div class="course-name">
              {{record.courseName}}
            </div>
            <div class="course-money">
              ￥{{record.realPrice}}元
            </div>
          </div>
        </div>

        <span slot="action" slot-scope="text, record" style="width:300px">
          <!-- <a @click="handleEdit(record)">编辑</a> -->
          <!-- <a-popconfirm title="确定下架吗?" v-if="record.courseStatus==1" @confirm="() => offShelfCourse(record.id)">
            <a>下架</a>
          </a-popconfirm>
          <a-popconfirm title="确定上架吗?"  v-else @confirm="() => offShelfCourse(record.id)">
            <a>上架</a>
          </a-popconfirm> -->
          <!-- <a-divider type="vertical" /> -->
          <!-- <a @click="courseDetail(record.id)">课程详情</a>
          <a-divider type="vertical" /> -->
          <a @click="courseEdite(record.id)">编辑</a>
          <a-divider type="vertical" />
          <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete1(record.id)"> -->
            <a>删除</a>
          <!-- </a-popconfirm> -->
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              
              <a-menu-item>
                
              </a-menu-item>
         
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <courseCreate-modal ref="modalForm" @ok="modalFormOk"/> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {updateShelf} from '@/api/api'
  // import CourseCreateModal from '../../../components/myCourse/myCourseList/CourseCreateModal'

  export default {
    name: "ClassList",
    mixins: [JeecgListMixin],
    components: {
      
    },
    data () {
      return {
        description: '课程管理页面',
        sex:"0",
        queryParam:{
          courseType:"",
          courseName:"",
          courseStatus:""
        },
        // 表头
        columns: [
         
          {
            title: '班级名称',
            align:"center",
            dataIndex: 'className',
            width:100
          },
          {
            title: '所属课程',
            align:"center",
            dataIndex: 'suoshu',
            width:100
          },
          {
            title: '开班/结班日期',
            align:"center",
            dataIndex: 'kaiban',
            width:200
          },
          {
            title: '班级状态',
            align:"center",
            dataIndex: 'bjzt',
            width:100
          },
          {
            title: '报名人数',
            align:"center",
            dataIndex: 'baiMing',
            width:100
          },
          {
            title: '已上课/排课次数',
            align:"center",
            dataIndex: 'paiTime',
            width:100
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
            width:260
          }
        ],
        dataSource1:[
          {
            'className':"拉丁舞A班",
            'suoshu':"拉丁舞",
            'kaiban':"2019-09-01/2020-07-01",
            'bjzt':"已开课",
            'baiMing':"100",
            'paiTime':"10"
          },
        ],
        // 请求参数
    	url: {
            list: "/course/list",
            delete: "/course/edit/delete",
            deleteBatch: "/course/elinkxCourse/deleteBatch",
            exportXlsUrl: "course/elinkxCourse/exportXls",
            importExcelUrl: "course/elinkxCourse/importExcel",
          },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },


    methods: {

      courseCreate(){
        this.$router.push({ path:'/classManage/classCreate'});
      },

      courseDetail(id){
        this.$router.push({ path:'/classManage/classCreate?courseId='+id});
      },
      courseEdite(id){
        this.$router.push({ path:'/classManage/classCreate?courseId='+id});
      },
      offShelfCourse(id){
        updateShelf({id:id}).then((res)=>{
          if(res.code==0){
            console.log(res)
            this.$message.success(res.message);
            this.loadData();

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      }

      

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >
  .course-img{
    float: left;
  }
  .course-right{
    padding-left:10px;
    text-align:left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left:90px;
    .course-name{
      font-size:14px;
      color: #0091FF;
      padding: 10px 0px;
    }
    .course-money{
      font-size:14px;
      color: #FA6400;
      
    }
  }
</style>